import React from 'react';
import { Table } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';

const Header = (props) => {
  const { t } = props;

  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.given_name')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.family_name')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.email')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.custom:year_of_birth')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.custom:occupation')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.custom:occupation_details')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.custom:country_of_residence')}*
        </Table.HeaderCell>
        <Table.HeaderCell collapsing>
          {t('private:addTeam.team.tableHeaders.custom:county_of_residence')}*
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
};

export default withNamespaces('private')(Header);



// WEBPACK FOOTER //
// ./src/private/common/components/Team/Form/Team/Members/Header.js